import {
  APPLICATION_ASSIGN,
  APPLICATION_ASSIGN_SUCCESS,
  APPLICATION_CALLNUMBER,
  APPLICATION_CALLNUMBER_FAILED,
  APPLICATION_CALLNUMBER_SUCCESS,
  APPLICATION_HIDE_ASSIGN_MODAL,
  APPLICATION_HIDE_CALLNUMBER_MODAL,
  APPLICATION_HIDE_MODAL,
  APPLICATION_LIST_FAILED,
  APPLICATION_LIST_LOADDATA,
  APPLICATION_LIST_LOADING,
  APPLICATION_LIST_SUCCESS,
  APPLICATION_MODAL_LOADING,
  APPLICATION_SHOW_ASSIGN_MODAL,
  APPLICATION_SHOW_CALLNUMBER_MODAL,
  APPLICATION_SHOW_MODAL,
  APPLICATION_STAGE_LOADDATA,
  APPLICATION_STAGE_SUCCESS,
  APPLICATION_STATUS_CHANGE,
  APPLICATION_STATUS_SUCCESS,
} from "../constants/ApplicationlistConst";

export const success = (data) => {
  return {
    type: APPLICATION_LIST_SUCCESS,
    data,
  };
};

export const stagessuccess = (data) => {
  return {
    type: APPLICATION_STAGE_SUCCESS,
    data,
  };
};

export const statuschangesuccess = (data) => {
  return {
    type: APPLICATION_STATUS_SUCCESS,
    data,
  };
};

export const failed = () => {
  return {
    type: APPLICATION_LIST_FAILED,
  };
};

export const loading = () => {
  return {
    type: APPLICATION_LIST_LOADING,
  };
};

export const modalloading = () => {
  return {
    type: APPLICATION_MODAL_LOADING,
  };
};

export const loaddata = ({ page, filter }) => {
  return {
    type: APPLICATION_LIST_LOADDATA,
    page,
    filter,
  };
};

export const loadstages = (id, app_id) => {
  return {
    type: APPLICATION_STAGE_LOADDATA,
    id,
    app_id,
  };
};

export const changeappstatus = (id, status, date, note) => {
  return {
    type: APPLICATION_STATUS_CHANGE,
    id: id,
    status: status,
    date: date,
    note: note,
  };
};

export const showModal = (id) => {
  return {
    type: APPLICATION_SHOW_MODAL,
    id,
  };
};

export const hideModal = () => {
  return {
    type: APPLICATION_HIDE_MODAL,
  };
};

export const showAssignModal = (id) => {
  return {
    type: APPLICATION_SHOW_ASSIGN_MODAL,
    id,
  };
};

export const hideAssignModal = () => {
  return {
    type: APPLICATION_HIDE_ASSIGN_MODAL,
  };
};

export const assignApplication = (id, branch_id, depo_id) => {
  return {
    type: APPLICATION_ASSIGN,
    id: id,
    branch_id: branch_id,
    depo_id: depo_id,
  };
};

export const assignsuccess = (data) => {
  return {
    type: APPLICATION_ASSIGN_SUCCESS,
    data,
  };
};

export const showCallNumberModal = (id) => {
  return {
    type: APPLICATION_SHOW_CALLNUMBER_MODAL,
    id,
  };
};

export const hideCallNumberModal = () => {
  return {
    type: APPLICATION_HIDE_CALLNUMBER_MODAL,
  };
};

export const updateCallNumber = (id, callno) => {
  return {
    type: APPLICATION_CALLNUMBER,
    id: id,
    callno: callno,
  };
};

export const callnumbersuccess = (data) => {
  return {
    type: APPLICATION_CALLNUMBER_SUCCESS,
    data,
  };
};

export const callnumberfailed = (message) => {
  return {
    type: APPLICATION_CALLNUMBER_FAILED,
    message,
  };
};
